export class ShopWindowMessage {

  bodyMessage: string;
  items: Array<string>;
  title: string;
  footerMessage: string;
  automaticTrialCouponFooterMessage: string;

  constructor(shopWindowMessageData?: any) {
    if (shopWindowMessageData) {
      this.bodyMessage = shopWindowMessageData.bodyMessage;
      this.items = shopWindowMessageData.items;
      this.title = shopWindowMessageData.title;
      this.footerMessage = shopWindowMessageData.footerMessage;
      this.automaticTrialCouponFooterMessage = shopWindowMessageData.automaticTrialCouponFooterMessage;
    }
  }
}
